let RecordDetail = [
  {
    uuid: "1",
    name: "Solution loading",
    description: "Description for Solution loading",
    link: "https://finsln.com/solution1.pdf",
  },
];
export default RecordDetail;
